import aemClientService from '@/services/aem/aemClientService';

let content: unknown;

export const initContent = async (marketName: string, languageCode: string) => {
    content = await aemClientService.initMarketContent(marketName?.toLowerCase(), languageCode?.toLowerCase());
};

export const getContent = () => content || {};
